import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import api from '../../api';

const TABS = ['General', 'Efectivo', 'Transferencia'];

export default function RevenueDetail() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState('General');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = { period: searchParams.get('period') || 'monthly' };
      const fd = searchParams.get('fromDate');
      const td = searchParams.get('toDate');
      if (fd && td) { params.from_date = fd; params.to_date = td; }
      const r = await api.get(`/analytics/revenue/${user.id}`, { params });
      setData(r.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const fmt = (n) => `$${(n || 0).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  const cashSales = data?.cash_total || 0;
  const transferSales = data?.transfer_total || 0;
  const cashEntries = data?.cash_entries_total || 0;
  const total = data?.total_revenue || 0;

  return (
    <div className="page-full">
      <div className="header">
        <button className="icon-btn" onClick={() => navigate(-1)}>←</button>
        <h1 className="header-title">Ingresos Totales</h1>
      </div>
      <div className="filter-tabs">
        {TABS.map(t => (
          <button key={t} className={`filter-tab ${tab === t ? 'active' : ''}`}
            onClick={() => setTab(t)}>{t}</button>
        ))}
      </div>
      <div className="content-scroll">
        {loading ? <div className="spinner" style={{ marginTop: '40px' }} /> : data && (
          <>
            {tab === 'General' && (
              <>
                <div className="stat-card" style={{ borderLeftColor: 'var(--accent)', borderLeftWidth: '4px' }}>
                  <div className="stat-label">Total Ingresos</div>
                  <div className="stat-value accent-text" style={{ fontSize: '28px' }}>{fmt(total)}</div>
                </div>
                <div className="detail-row"><span>💵</span><span style={{ flex: 1 }}>Efectivo</span><span className="green-text" style={{ fontWeight: '700' }}>{fmt(cashSales)}</span></div>
                <div className="detail-row"><span>📱</span><span style={{ flex: 1 }}>Transferencia</span><span className="accent-text" style={{ fontWeight: '700' }}>{fmt(transferSales)}</span></div>
                <div className="detail-row"><span>💰</span><span style={{ flex: 1 }}>Ingreso de Caja</span><span style={{ fontWeight: '700', color: '#6C63FF' }}>{fmt(cashEntries)}</span></div>
              </>
            )}
            {tab === 'Efectivo' && (
              <>
                <div className="stat-card" style={{ borderLeftColor: '#4CAF50', borderLeftWidth: '4px' }}>
                  <div className="stat-label">Total Efectivo</div>
                  <div className="stat-value green-text" style={{ fontSize: '28px' }}>{fmt(cashSales)}</div>
                </div>
                <div className="info-box"><span style={{ fontSize: '36px' }}>💵</span><p className="card-row-detail">Ventas cobradas en efectivo durante el período seleccionado</p></div>
              </>
            )}
            {tab === 'Transferencia' && (
              <>
                <div className="stat-card" style={{ borderLeftColor: 'var(--accent)', borderLeftWidth: '4px' }}>
                  <div className="stat-label">Total Transferencia</div>
                  <div className="stat-value accent-text" style={{ fontSize: '28px' }}>{fmt(transferSales)}</div>
                </div>
                <div className="info-box"><span style={{ fontSize: '36px' }}>📱</span><p className="card-row-detail">Ventas cobradas por transferencia durante el período seleccionado</p></div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
